import { baseApiQuery, blobResponseHandler } from '@/shared/helpers/api';
import { createApi } from '@reduxjs/toolkit/query/react';
import { t } from '@/core/localization';
import { getErrorFromException } from '@/core/utils/errorHandling';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
import { enqueueSnackbar } from 'notistack';
// TODO: later during stock refactoring , remove this endpoints from shared and move to admin since nothing is used in
// Warehouse now?  CHECK.
export const stockBaseApi = createApi({
    reducerPath: 'api/stock',
    tagTypes: ['StockList', 'Stock'],
    baseQuery: baseApiQuery,
    endpoints: (builder) => ({
        getStockList: builder.query({
            query: () => {
                return {
                    method: 'GET',
                    url: 'stock/stockslist',
                };
            },
            transformResponse: (response) => ({
                stock: response[1],
                transfer: response[2],
            }),
            providesTags: ['StockList'],
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.stock.list.request.failed'), error }));
                }
            },
        }),
        getStockInfo: builder.query({
            query: (stockId) => {
                return {
                    method: 'GET',
                    url: `stock/getStock/${stockId}`,
                };
            },
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.stock.info.request.failed'), error }));
                }
            },
        }),
        getStockBalance: builder.query({
            query: ({ stockId, grouped }) => {
                return {
                    method: 'GET',
                    url: 'stock/stockBalance',
                    params: { type: grouped ? 2 : 1, stockId },
                };
            },
            transformResponse: (response, meta, { grouped }) => grouped ? response : [{ cell: undefined, stockItems: response }],
            providesTags: ['Stock'],
        }),
        exportStockToExcel: builder.mutation({
            queryFn: async ({ stockId }, api, extraOptions, baseQuery) => {
                const result = (await baseQuery({
                    method: 'GET',
                    url: `Stock/exportStockToXlsx/${stockId}`,
                    cache: 'no-cache',
                    // responseHandler: (response) => response.blob(),
                    responseHandler: blobResponseHandler,
                }));
                if (result.error) {
                    enqueueSnackbar({
                        variant: 'error',
                        header: t('file.download.failed'),
                        body: getErrorFromException(result.error),
                        persist: true,
                    });
                    return { data: null };
                }
                // TODO: extract (same used in other api's (Warehouse > receipt.api))
                const hiddenElement = document.createElement('a');
                const url = window.URL || window.webkitURL;
                const blob = url.createObjectURL(result.data);
                hiddenElement.href = blob;
                hiddenElement.target = '_blank';
                hiddenElement.download = `${t('file.name.stock')}.xlsx`;
                hiddenElement.click();
                URL.revokeObjectURL(blob);
                return { data: null };
            },
        }),
        // // If we want Lazy, then we should use queryFn instead of query and stockItemId as undefined to "clear" result. Workaround since useLazeQuery cant skip.
        // getStockItemCostHistory: builder.query<IStockBalanceCostHistoryItem[], { stockItemId?: number }>({
        // 	query: ({ stockItemId }) => ({
        // 		method: 'GET',
        // 		url: `stock/stockBalanceHistory/${stockItemId}`,
        // 	}),
        // 	// // @ts-ignore
        // 	// queryFn: async (arg, api, extraOptions, baseQuery) => {
        // 	// 	if (!arg.stockItemId) return { data: undefined };
        // 	// 	const result = await baseQuery({
        // 	// 		method: 'GET',
        // 	// 		url: `stock/stockBalanceHistory/${arg.stockItemId}`,
        // 	// 	});
        // 	// 	if (result.error) return { error: result.error, data: null };
        // 	// 	const data = result.data as (Omit<IStockItemCostHistoryItem, 'created'> & { created: string })[];
        // 	// 	return {
        // 	// 		data: data.map((historyItem) => ({
        // 	// 			...historyItem,
        // 	// 			created: new Date(historyItem.created),
        // 	// 		})),
        // 	// 	};
        // 	// },
        // 	// transformResponse not working with queryFn.
        // 	transformResponse: (response: (Omit<IStockBalanceCostHistoryItem, 'created'> & { created: string })[]) =>
        // 		response.map((historyItem) => ({
        // 			...historyItem,
        // 			created: new Date(historyItem.created),
        // 		})),
        // 	providesTags: ['Stock'],
        // }),
        // TODO: refactor. Old
        getCrossdockingList: builder.query({
            // TODO: refactor. This endpoint is duplicated. It is used in Admin > Settings > Warehouses, and in
            // Warehouse > CrossdockingSelect component.
            query: () => 'crossdocking',
            // TODO: to return later when separate 'crossdocking' endpoint will be added.
            // providesTags: (result) => providesList(result, 'Crossdocking'),
        }),
        getStockLocations: builder.query({
            query: () => 'location',
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.locations.request.failed'), error }));
                }
            },
        }),
        // TODO: to delete later
        // relocateStockItem: builder.mutation<{ error: string; success: boolean }, StockItemRelocate>({
        // 	query: (body) => ({
        // 		method: 'POST',
        // 		url: 'stock/relocate',
        // 		body,
        // 	}),
        // 	// invalidatesTags: (result, error, stockItems) => stockItems.map((item) => ({ type: 'StockItem', id: item.stockItemId })),
        // 	invalidatesTags: (result, error, stockItems) => [{ type: 'Stock' }, { type: 'StockList' }],
        // }),
    }),
});
export const { useGetStockListQuery, useGetStockInfoQuery, useGetStockBalanceQuery, useExportStockToExcelMutation, useGetStockLocationsQuery, } = stockBaseApi;
